<template>
  <div class="wrapper">
    <h1 class="underline-header" >新規会員登録</h1>
    <section class="text-wrapper">
      <p class="p-form p-form--single">
      仮登録を行い、ご入力いただいたメールアドレスに本登録用メールをお送りいたしました。<br/>
      受信されているかご確認いただき、メールに記載のURLから本登録へお進みください。<br/>
      </p>
      <p class="p-form p-form--single c-sub-text">
        ※メール受信制限をされている方は、「ki-group.co.jp」からの受信許可設定をしてください。
      </p>
    </section>

  </div>
</template>

<script>

export default {
  name: 'MemberRegist',
  data() {
    return {
      isConfirmAutoLogin: false,
      isLoading: false,
    };
  },
  created() {
    if (this.$store.state.user) {
      this.$emit('update', 'form');
    }
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">
@charset "UTF-8";
@import "../../../assets/style/parts_responsive.scss";

.text-wrapper {
  min-height: 540px;
}

.p-button input[type=button]{
  margin:0;
}

.c-autologin{
  font-size:14px;
  padding:12px;
  text-align:center;
}

.c-agreement{
  font-size:10px;
  padding: 12px;
  text-align: center;
}

.c-forgetpassword {
  padding: 12px;
  text-align:right;
}

.p-form--single {
  font-size: 14px;
  padding: 2px 12px;
  line-height: 32px;
}

.c-sub-text {
  font-size: 12px;
  margin-top: 16px !important;
}

@media(min-width: 640px) {
  .text-wrapper {
    min-height: 0px;
  }

  .underline-header {
    text-align: center;
  }

  .wrapper {
    margin: auto;
    max-width: 720px;
    text-align: center;
    min-height: 600px;
  }

  .text-wrapper {
    margin-top: 22px;
    flex-direction: column;
    display: flex;
    p {
      margin: auto;
    }
  }

  .p-form--single {
    font-size: 16px;
    padding: 2px 0px;
  }

  .c-sub-text {
    font-size: 14px;
  }
}

</style>
